import { text } from '@clack/prompts'

import { Command } from 'commander'
import as from 'ansis'

import { apiService } from '@/helpers'
import { output } from '@/helpers/std-out'

export const UpdateCommand = () => {
  const cmd = new Command('update')

  cmd.description('Update document metadata on scalar registry')
  cmd.argument('[namespace]', 'namespace of document you want to update')
  cmd.argument('[slug]', 'slug of document you want to update')
  cmd.option('--title <title>', 'Document title')
  cmd.option('--description <description>', 'Document description')
  cmd.action(async (namespace, slug, { title, description }) => {
    const client = await apiService()

    if (!namespace) {
      return output
        .error()
        .title('Invalid input')
        .message('Please provide namespace of the document')
        .exit('error')
    }

    if (!slug) {
      return output
        .error()
        .title('Invalid input')
        .message('Please provide slug of the document')
        .exit('error')
    }

    let titleValue = title
    let descriptionValue = description

    const shouldPrompt = ![title, description].some((it) => it !== undefined)

    if (!titleValue && shouldPrompt) {
      titleValue = await text({
        message: `What is the new title of your document? ${as.grey('(Optional)')}`,
      })
    }

    if (!descriptionValue && shouldPrompt) {
      descriptionValue = await text({
        message: `What is the new description of your document?  ${as.grey('(Optional)')}`,
      })
    }

    if (!titleValue && !descriptionValue) {
      return output
        .error()
        .title('Invalid input')
        .message('Please provide any field to update')
        .exit('error')
    }

    const logger = output.info().line().loader('Updating the api document')
    const updateDocument = await client.managedDocs.update(namespace, slug, {
      title: titleValue,
      description: descriptionValue,
      isPrivate: false,
    })

    if (updateDocument.error) {
      return output.error().title(updateDocument.message).exit('error')
    }

    logger
      .update('loader', 0, {
        content: 'Successfully updated document metadata.',
      })
      .print()
  })

  return cmd
}
